// @flow
export { default } from './TextInput';
export type { Props } from './TextInput';



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/TextInput/index.js